<script lang="ts">
  import { page } from '$app/stores';
  import { Bookmaker } from '$utils/bookmakers';

  $: ({ layoutConfigStore } = $page.data);
  $: activeLayoutConfig = layoutConfigStore?.activeLayoutConfig;
  const directions = [
    'H_BARRIER',
    'H_BARRIER_DESC',
    'PRICE_ASC',
    'PRICE_DESC',
    'BARRIER'
  ] as const;
  const options = new Map<(typeof directions)[number], string>();
  options.set('BARRIER', 'Number'); // lol this is not meant to be barrier
  options.set('H_BARRIER', 'Barrier Ascending'); // lol this is not meant to be barrier
  options.set('H_BARRIER_DESC', 'Barrier Descending');
  options.set('PRICE_ASC', 'Price Ascending');
  options.set('PRICE_DESC', 'Price Descending');

  const bookmakers = new Map<Bookmaker, string>();
  for (const bookmaker of Object.values(Bookmaker).sort()) {
    bookmakers.set(bookmaker, bookmaker);
  }

  function handleBookmakerSelect(e: Event) {
    const target = e.target as HTMLSelectElement;

    if (!layoutConfigStore || !$activeLayoutConfig) {
      // console.error('no layout config');
      return;
    }

    $activeLayoutConfig.runnerSort;

    layoutConfigStore.updateOne({
      ...$activeLayoutConfig,
      //   @ts-expect-error this is typechecked above
      runnerPriceSortBookmaker: target.value
    });
  }

  function handleSelect(e: Event) {
    const target = e.target as HTMLSelectElement;

    if (!layoutConfigStore || !$activeLayoutConfig) {
      // console.error('no layout config');
      return;
    }

    $activeLayoutConfig.runnerSort;

    layoutConfigStore.updateOne({
      ...$activeLayoutConfig,
      //   @ts-expect-error this is typechecked above
      runnerSort: target.value
    });
  }

  $: hasSortDirection =
    $activeLayoutConfig?.runnerSort !== 'BARRIER' &&
    $activeLayoutConfig?.runnerSort !== 'H_BARRIER' &&
    $activeLayoutConfig?.runnerSort !== 'H_BARRIER_DESC';
</script>

<div>
  <label for="layouts" class="block text-sm font-medium leading-6 text-gray-900"
    >Runner Sort Direction</label
  >
  <select
    on:change={handleSelect}
    id="layouts"
    name="layouts"
    class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
  >
    {#each [...options] as [key, value]}
      <option value={key} selected={key === $activeLayoutConfig?.runnerSort}
        >{value}</option
      >
    {/each}
  </select>
</div>
{#if hasSortDirection}
  <div>
    <label
      for="layouts"
      class="block text-sm font-medium leading-6 text-gray-900"
      >Runner Sort Bookmaker</label
    >
    <select
      on:change={handleBookmakerSelect}
      id="runnerSortBookmaker"
      name="runnerSortBookmaker"
      class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
    >
      {#each [...bookmakers] as [key, value]}
        <option
          value={key}
          selected={key === $activeLayoutConfig?.runnerPriceSortBookmaker}
          >{value}</option
        >
      {/each}
    </select>
  </div>
{/if}
